var __jsx = React.createElement;
import React from 'react';
import Head from 'next/head';
import Grid from '@mui/material/Grid';
import { useQuery } from '@apollo/client';
import VerficationAlert from '@molecules/common/VerficationAlert';
import Header from '@organisms/common/Header';
import Sidebar from '@organisms/common/Sidebar';
import { GET_SIDEBAR_STATUS, USER_QUERY } from '@app/apollo/queries';
import { BoxContianer, LayoutContainer, ContentContainer, VerficationContainer } from './style';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var HeaderWithSidebar = function HeaderWithSidebar(_ref) {
  var children = _ref.children,
    title = _ref.title,
    contentPadding = _ref.contentPadding,
    style = _ref.style;
  var _useQuery = useQuery(GET_SIDEBAR_STATUS),
    _useQuery$data = _useQuery.data;
  _useQuery$data = _useQuery$data === void 0 ? {
    sidebarOpen: false
  } : _useQuery$data;
  var sidebarOpen = _useQuery$data.sidebarOpen,
    client = _useQuery.client;
  var _useQuery2 = useQuery(USER_QUERY),
    data = _useQuery2.data,
    loading = _useQuery2.loading;
  var user = (data === null || data === void 0 ? void 0 : data.me) || null;
  var toggleSidebar = function toggleSidebar() {
    client.writeQuery({
      query: GET_SIDEBAR_STATUS,
      data: {
        sidebarOpen: !sidebarOpen
      }
    });
  };

  // console.log("user", user)
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: "Mubazar ".concat(title)
      })
    }), /*#__PURE__*/_jsxs(LayoutContainer, {
      children: [/*#__PURE__*/_jsx(Header, {
        sidebar: !!user,
        onClick: toggleSidebar
      }), /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs(ContentContainer, {
          children: [user && /*#__PURE__*/_jsx(Sidebar, {
            isOpen: sidebarOpen,
            userInfo: user
          }), /*#__PURE__*/_jsx(BoxContianer, {
            contentPadding: contentPadding,
            isOpen: sidebarOpen,
            hasSidebar: !!user,
            style: style,
            children: /*#__PURE__*/_jsxs(LayoutContainer, {
              children: [!loading && user && !user.is_verified ? /*#__PURE__*/_jsx(VerficationContainer, {
                children: /*#__PURE__*/_jsx(VerficationAlert, {})
              }) : /*#__PURE__*/_jsx(VerficationContainer, {}), /*#__PURE__*/_jsx(Grid, {
                item: true,
                xs: 12,
                sm: 12,
                children: children
              })]
            })
          })]
        })
      })]
    })]
  });
};
HeaderWithSidebar.defaultProps = {
  title: '',
  contentPadding: 2,
  children: undefined,
  style: {}
};
export default HeaderWithSidebar;